import { render, staticRenderFns } from "./UserFollow.vue?vue&type=template&id=4d93233c"
import script from "./UserFollow.vue?vue&type=script&lang=js"
export * from "./UserFollow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports